// Canonical param-key → human label map. One source of truth for
// surfacing param names in copy — Overview headlines, dose-aware
// Sensei advice, email subjects, and the dose_stopped notification
// renderer. Falls back to the raw key when the keeper has a custom
// param the table doesn't know.
//
// The keys here mirror DEFAULT_PARAM_TEMPLATES in server/db/seeds/
// index.js but stay independent — DEFAULT_PARAM_TEMPLATES carries
// per-param bands and units the keeper can override, while these
// labels are immutable English copy used by code that doesn't (and
// shouldn't) reach into the seeds bundle.
//
// Capitalised forms ("Alkalinity") for headlines / sentences;
// lowercase ("alkalinity") for mid-sentence ("dosed 28 mL of
// alkalinity"). Both shapes live here so callers don't reinvent
// either one.

export const PARAM_LABEL = {
  alk: 'Alkalinity',
  calcium: 'Calcium',
  magnesium: 'Magnesium',
  salinity: 'Salinity',
  temp: 'Temperature',
  ph: 'pH',
  nitrate: 'Nitrate',
  phosphate: 'Phosphate',
  ammonia: 'Ammonia',
  nitrite: 'Nitrite',
  kh: 'KH',
  gh: 'GH',
  tds: 'TDS',
};

export const PARAM_LABEL_LOWER = {
  alk: 'alkalinity',
  calcium: 'calcium',
  magnesium: 'magnesium',
  salinity: 'salinity',
  temp: 'temperature',
  ph: 'pH', // pH stays capitalised mid-sentence — it's an acronym
  nitrate: 'nitrate',
  phosphate: 'phosphate',
  ammonia: 'ammonia',
  nitrite: 'nitrite',
  // Freshwater hardness and dissolved solids are written as acronyms.
  kh: 'KH',
  gh: 'GH',
  tds: 'TDS',
};

const own = (map, key) => (Object.hasOwn(map, key) ? map[key] : undefined);

export function paramLabel(key) {
  return own(PARAM_LABEL, key) || key;
}

export function paramLabelLower(key) {
  return own(PARAM_LABEL_LOWER, key) || key;
}
